// import defaultAccess from "@/modules/Employee/components/access"

export default {
    namespaced: true,
    state: {
        employee: {},
    },
    getters: {
        employee(state) {
            return state.employee;
        },
    },
    actions: {
        setEmployee({
            commit
        }, payload) {
            commit('setEmployee', payload);
        }
    },
    mutations: {
        setEmployee(state, payload) {
            // if (payload.metadata && payload.metadata.timeClockLogin && !payload.metadata.timeClockLogin.access) {
            //     payload.metadata.timeClockLogin.access = defaultAccess
            // }
            state.employee = payload;
        }
    }
}